import Vue from "vue";
import Router from "vue-router";
import { getTenantId } from "../utils";
// import index from '@/pages/index'
// import productList from '@/pages/productList'
// import service from '@/pages/service'
// import favorites from '@/pages/favorites'
// import shopping from '@/pages/shopping'
// import scan from '@/pages/scan'
// import countrys from '@/pages/countrys'

// import login from '@/pages/login/index'
// import loginText from '@/pages/login/text'
// import loginEmail from '@/pages/login/email'
// import register from '@/pages/login/register'
// import registerEmail from '@/pages/login/register-email'

const index = () => import("@/pages/index");
const productList = () => import("@/pages/productList");
const service = () => import("@/pages/service");
const favorites = () => import("@/pages/favorites");
const shopping = () => import("@/pages/shopping");
const scan = () => import("@/pages/scan");
const scanPlus = () => import("@/pages/scan5");
const scanRaw = () => import("@/pages/scan6");
const countrys = () => import("@/pages/countrys");

const login = () => import("@/pages/login/index");
const loginText = () => import("@/pages/login/text");
const loginEmail = () => import("@/pages/login/email");
const register = () => import("@/pages/login/register");
const registerEmail = () => import("@/pages/login/register-email");

// const  completeInfo  = () => import('@/pages/login/info')

// import registerSuccess from '@/pages/login/success'
// import retrieve from '@/pages/login/retrieve/index'
// import google from '@/pages/login/google'

// import cases from '@/pages/cases/index'
// import casesDetail from '@/pages/cases/detail'
// import casesList from '@/pages/cases/related'
// import casesSubject from '@/pages/cases/subject'

// import collections from '@/pages/collections/index'
// import collectionsClass from '@/pages/collections/class'
// import collectionsDetail from '@/pages/collections/detail'
// import collectionsCenter from '@/pages/collections/center'

// import templateIndex from '@/pages/template/index'
// import templateDetail from '@/pages/template/detail'
// import templateRecord from '@/pages/template/record'

// import brand from '@/pages/brand/index'
// import brandDetail from '@/pages/brand/detail'

// import search from '@/pages/search/index'
// import searchResult from '@/pages/search/result'
// import searchstore from '@/pages/search/store'

// import appointment from '@/pages/appointment/index'
// import appointmentInfo from '@/pages/appointment/info'
// import appointmentSuccess from '@/pages/appointment/success'
// import appointmentCode from '@/pages/appointment/code'
// import appointmentRecord from '@/pages/appointment/record'
// import appointmentBrowse from '@/pages/appointment/browse'
// import appointmentDetail from '@/pages/appointment/detail'

// import person from '@/pages/person/index'
// import personRecently from '@/pages/person/recently'
// import setting from '@/pages/person/setting/index'
// import settingInfo from '@/pages/person/setting/info'
// import settingSecurity from '@/pages/person/setting/security'
// import mycases from '@/pages/person/cases'

// import calculator from '@/pages/calculator/index'
// import calculatorAdd from '@/pages/calculator/add'
// import calculatorDelete from '@/pages/calculator/delete'

// import test from '@/pages/test'
// import ShoppingList from '@/pages/ShoppingList'

const registerSuccess = () => import("@/pages/login/success");
const retrieve = () => import("@/pages/login/retrieve/index");
const google = () => import("@/pages/login/google");

const cases = () => import("@/pages/cases/index");
const casesDetail = () => import("@/pages/cases/detail");
const casesList = () => import("@/pages/cases/related");
const casesSubject = () => import("@/pages/cases/subject");

const collections = () => import("@/pages/collections/index");
const collectionsClass = () => import("@/pages/collections/class");
const collectionsDetail = () => import("@/pages/collections/detail");
const collectionsCenter = () => import("@/pages/collections/center");

const templateIndex = () => import("@/pages/template/index");
const templateDetail = () => import("@/pages/template/detail");
const templateRecord = () => import("@/pages/template/record");
const templateMatch = () => import("@/pages/template/match");

const brand = () => import("@/pages/brand/index");
const brandDetail = () => import("@/pages/brand/detail");

const search = () => import("@/pages/search/index");
const searchResult = () => import("@/pages/search/result");
const searchstore = () => import("@/pages/search/store");

const appointment = () => import("@/pages/appointment/index");
const appointmentInfo = () => import("@/pages/appointment/info");
const appointmentSuccess = () => import("@/pages/appointment/success");
const appointmentCode = () => import("@/pages/appointment/code");
const appointmentRecord = () => import("@/pages/appointment/record");
const appointmentBrowse = () => import("@/pages/appointment/browse");
const appointmentDetail = () => import("@/pages/appointment/detail");

const person = () => import("@/pages/person/index");
const personRecently = () => import("@/pages/person/recently");
const setting = () => import("@/pages/person/setting/index");
const settingInfo = () => import("@/pages/person/setting/info");
const settingSecurity = () => import("@/pages/person/setting/security");
const mycases = () => import("@/pages/person/cases");

import businessSchool from "@/pages/school/index";
import myLearn from "@/pages/school/myLearn";
import learnDetail from "@/pages/school/detail";
import learnRank from "@/pages/school/rank";
import survey from "@/pages/school/survey";
import learningHistory from "@/pages/school/learningHistory";
import favourite from "@/pages/school/favourite";
import course from "@/pages/school/course";
import searchCase from "@/pages/school/search";
import searchCaseResult from "@/pages/school/result";

const calculator = () => import("@/pages/calculator/index");
const calculatorAdd = () => import("@/pages/calculator/add");
const calculatorDelete = () => import("@/pages/calculator/delete");

const test = () => import("@/pages/test");
const ShoppingList = () => import("@/pages/ShoppingList");

import { keepAlivePage, intercept } from "./middleware";

Vue.use(Router);

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// 通用路由跳转处理函数
const handleRouteNavigation = function (originalMethod, location) {
  // 确保每次跳转都携带tenantId和lang参数
  try {
    // 如果是字符串路径，转换为对象格式
    let locationObj =
      typeof location === "string" ? { path: location } : { ...location };

    // 获取当前路由的query参数，用于继承tenantId和lang
    const currentQuery = this.currentRoute.query || {};

    // 确保query对象存在
    locationObj.query = { ...locationObj.query };

    // 继承或覆盖tenantId和lang参数
    // 如果目标路由没有指定这些参数，但当前路由有，则继承
    if (currentQuery.tenantId && !locationObj.query.tenantId) {
      locationObj.query.tenantId = currentQuery.tenantId;
    } else if (getTenantId()) {
      // console.log(getTenantId());
      locationObj.query.tenantId = getTenantId();
    }
    if (currentQuery.lang && !locationObj.query.lang) {
      locationObj.query.lang = currentQuery.lang;
    } else if (localStorage.getItem("language")) {
      locationObj.query.lang = localStorage.getItem("language");
    }

    return originalMethod.call(this, locationObj).catch((err) => err);
  } catch (error) {
    // 如果获取当前路由失败，使用原始跳转
    return originalMethod.call(this, location).catch((err) => err);
  }
};

//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return handleRouteNavigation.call(this, originalPush, location);
};

//修改原型对象中的replace方法
Router.prototype.replace = function replace(location) {
  return handleRouteNavigation.call(this, originalReplace, location);
};

const router = new Router({
  // mode:"history",
  routes: [
    {
      path: "/test",
      name: "test",
      component: test,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/ShoppingList",
      name: "ShoppingList",
      component: ShoppingList,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/product-list",
      name: "productList",
      component: productList,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/service",
      name: "service",
      component: service,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/favorites",
      name: "favorites",
      component: favorites,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/shopping",
      name: "shopping",
      component: shopping,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/scan",
      name: "scan",
      component: scanRaw,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/scan-plus",
      name: "scanPlus",
      component: scanPlus,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/scan-old",
      name: "scanOld",
      component: scan,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/countrys",
      name: "countrys",
      component: countrys,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/login-text",
      name: "loginText",
      component: loginText,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/login-email",
      name: "loginEmail",
      component: loginEmail,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/register-email",
      name: "registerEmail",
      component: registerEmail,
      meta: {
        keepAlive: false,
      },
    },
    // {
    //   path: '/complete-info',
    //   name: 'completeInfo',
    //   component: completeInfo,
    //   meta: {
    //     keepAlive: false
    //   }
    // },
    {
      path: "/register-success",
      name: "registerSuccess",
      component: registerSuccess,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/retrieve",
      name: "retrieve",
      component: retrieve,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/google",
      name: "google",
      component: google,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/cases",
      name: "cases",
      component: cases,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/cases-detail",
      name: "casesDetail",
      component: casesDetail,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/cases-list",
      name: "casesList",
      component: casesList,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/cases-subject",
      name: "casesSubject",
      component: casesSubject,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/template",
      name: "template",
      component: templateIndex,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/template-detail",
      name: "templatedetail",
      component: templateDetail,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/template-record",
      name: "templaterecord",
      component: templateRecord,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/template-match",
      name: "templatematch",
      component: templateMatch,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/product",
      name: "product",
      component: collections,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/product-class",
      name: "productClass",
      component: collectionsClass,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/product-detail",
      name: "productDetail",
      component: collectionsDetail,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/product-center",
      name: "productCenter",
      component: collectionsCenter,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/brand",
      name: "brand",
      component: brand,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/brand-detail",
      name: "brandDetail",
      component: brandDetail,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/search",
      name: "search",
      component: search,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/search-result",
      name: "searchresult",
      component: searchResult,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/search-store",
      name: "searchstore",
      component: searchstore,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/search-case-result",
      name: "searchcaseresult",
      component: searchCaseResult,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/appointment",
      name: "appointment",
      component: appointment,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/appointment-info",
      name: "appointmentinfo",
      component: appointmentInfo,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/appointment-success",
      name: "appointmentSuccess",
      component: appointmentSuccess,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/appointment-code",
      name: "appointmentCode",
      component: appointmentCode,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/appointment-record",
      name: "appointmentRecord",
      component: appointmentRecord,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/appointment-browse",
      name: "appointmentBrowse",
      component: appointmentBrowse,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/appointment-detail",
      name: "appointmentDetail",
      component: appointmentDetail,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/person",
      name: "person",
      component: person,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/person-recently",
      name: "personRecently",
      component: personRecently,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/setting",
      name: "setting",
      component: setting,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/setting-info",
      name: "settingInfo",
      component: settingInfo,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/setting-security",
      name: "settingSecurity",
      component: settingSecurity,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/person-cases",
      name: "mycases",
      component: mycases,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/business-school",
      name: "businessSchool",
      component: businessSchool,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/my-learn",
      name: "myLearn",
      component: myLearn,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/learn-detail",
      name: "learnDetail",
      component: learnDetail,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/learn-rank",
      name: "learnRank",
      component: learnRank,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/survey",
      name: "survey",
      component: survey,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/learning-history",
      name: "learningHistory",
      component: learningHistory,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/favourite",
      name: "favourite",
      component: favourite,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/course",
      name: "course",
      component: course,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/search-case",
      name: "searchcase",
      component: searchCase,
      meta: {
        keepAlive: false,
      },
    },

    {
      path: "/calculator",
      name: "calculator",
      component: calculator,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/calculator-add",
      name: "calculatorAdd",
      component: calculatorAdd,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/calculator-delete",
      name: "calculatorDelete",
      component: calculatorDelete,
      meta: {
        keepAlive: false,
      },
    },
  ],
});

router.beforeResolve((to, from, next) => {
  keepAlivePage(to, from, next); // 判断是否需要保留页面
  intercept(to, from, next);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js